import { useEffect, useState } from "react";
import { entListAudit } from "../salaryEnterpriseApi";

export default function SalaryAuditTimeline() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    entListAudit({ limit: 50 })
      .then((d) => setRows(d || []))
      .catch(() => setRows([]));
  }, []);

  return (
    <div className="bw-stack">
      <h2 className="bw-section-title">Audit timeline</h2>
      <ul className="space-y-3">
        {rows.map((r) => (
          <li key={r.audit_id} className="rounded-lg border border-slate-200 bg-white p-4 shadow-sm">
            <div className="flex justify-between text-sm">
              <strong>{r.action}</strong>
              <span className="text-slate-500">{new Date(r.created_at).toLocaleString()}</span>
            </div>
            <p className="text-xs text-slate-600 mt-1">
              {r.entity_type} · {r.entity_id}
            </p>
            {r.reason ? <p className="text-sm mt-2">{r.reason}</p> : null}
          </li>
        ))}
        {rows.length === 0 ? <p className="text-sm text-slate-500">No audit entries yet.</p> : null}
      </ul>
    </div>
  );
}
